import axios from "axios";

export default {
    state: () => ({
        bookingList : null,
        booking : null,
        historyList : null,
        passengers : null,
        changeResponse : null,
        checkBookingPayments : null,
        reservationEdit : false,
        bookingNotes: null,
        bookingNote: null,
        bookingNoteType: null,
        bookingActionHistoryList: null,
        reCalculate: false
    }),
    mutations: {
        setBooking:function (state,booking){
            state.booking = booking
        },
        setPassengers:function (state,passengers){
            state.passengers = passengers;
        },
        setHistoryList:function (state,historyList){
            state.historyList = historyList;
        },

        setContactEmail:function (state,contactEmail){
            state.contactEmail = contactEmail;
        },
        setContactPhone:function (state,contactPhone){
            state.contactPhone = contactPhone;
        },
        setContactName:function (state,contactName){
            state.contactName = contactName;
        },
        setEmergencyContactEmail:function (state,emergencyContactEmail){
            state.emergencyContactEmail = emergencyContactEmail;
        },
        setEmergencyContactPhone:function (state,emergencyContactPhone){
            state.emergencyContactPhone = emergencyContactPhone;
        },
        setEmergencyContactName:function (state,emergencyContactName){
            state.emergencyContactName = emergencyContactName;
        },
        setChangeResponse : function (state,changeResponse){
            state.changeResponse = changeResponse;
        },
        setCheckBookingPayments : function (state,checkBookingPayments){
            state.checkBookingPayments = checkBookingPayments;
        },

        setReservationEdit : function (state,reservationEdit){
            state.reservationEdit = reservationEdit
        },
        setBookingNotes : function (state, bookingNotes){
            state.bookingNotes = bookingNotes;
        },
        setBookingNote : function (state, bookingNote){
            state.bookingNote = bookingNote;
        },
        setBookingNoteType : function (state, bookingNoteType){
            state.bookingNoteType = bookingNoteType;
        },
        clearBookingState(state){
            state.booking = null;
            state.passengers = null;
            state.sail = null;
            state.contactEmail = null;
            state.contactPhone = null;
            state.contactName = null;
            state.emergencyContactEmail = null;
            state.emergencyContactPhone = null;
            state.emergencyContactName = null;
        },
        setBookingActionHistoryList : function (state, bookingActionHistoryList){
            state.bookingActionHistoryList = bookingActionHistoryList;
        },
        setReCalculate : function (state, reCalculate){
            state.reCalculate = reCalculate;
        }
    },
    getters: {
        getBooking : state => {
            return state.booking
        },
        getPassengers : state => {
            return state.passengers;
        },
        getContactEmail : state => {
            return state.contactEmail
        },
        getContactPhone : state => {
            return state.contactPhone
        },
        getContactName : state => {
            return state.contactName
        },
        getEmergencyContactEmail : state => {
            return state.emergencyContactEmail
        },
        getEmergencyContactPhone : state => {
            return state.emergencyContactPhone
        },
        getEmergencyContactName : state => {
            return state.emergencyContactName
        },
        getChangeResponse : state => {
            return state.changeResponse
        },
        getCheckBookingPayments : state => {
            return state.checkBookingPayments
        },
        getHistoryList : state => {
            return state.historyList
        },
        getReservationEdit : state => {
            return state.reservationEdit;
        },
        getBookingNotes : state => {
            return state.bookingNotes;
        },
        getBookingNote : state => {
            return state.bookingNote;
        },
        getBookingNoteType : state => {
            return state.bookingNoteType;
        },
        getBookingActionHistoryList : state => {
            return state.bookingActionHistoryList;
        },
        getReCalculate : state => {
            return state.reCalculate;
        }
    },
    actions:{
        loadBookingList : (context) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/booking",{headers})
                .then((response) => {

                    let bookingList = response.data;

                    bookingList.sort((a, b) => {
                        var dateA = new Date(a.createDate);
                        var dateB = new Date(b.createDate);
                        return dateB - dateA;
                    });
                    return bookingList;
                })
        },
        loadBookingArchivedList : (context) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/booking/archived",{headers})
                .then((response) => {

                    let bookingList = response.data;

                    bookingList.sort((a, b) => {
                        var dateA = new Date(a.createDate);
                        var dateB = new Date(b.createDate);
                        return dateB - dateA;
                    });

                    return bookingList;
                })
        },
        loadBookingListBetween : (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/between",request,{headers})
                .then((response) => {

                    let bookingList = response.data;

                    bookingList.sort((a, b) => {
                        var dateA = new Date(a.createDate);
                        var dateB = new Date(b.createDate);
                        return dateB - dateA;
                    });

                    return bookingList;
                })
        },
        loadBooking(context, id){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+id,{headers})
                .then((response) => {
                    context.commit("setBooking",response.data)

                    let passengers = response.data.bookingPassengers;
                    for(let i=0;i<passengers.length;i++){
                        passengers[i].cruiseRoomId = passengers[i].bookingRoom.cruiseRoomId
                    }

                    this.commit("setPassengers", passengers)
                    this.commit("setSail", response.data.sail);
                    this.commit("setContactEmail", response.data.contactEmail)
                    this.commit("setContactPhone", response.data.contactPhone)
                    this.commit("setContactName", response.data.contactName)
                    this.commit("setEmergencyContactEmail", response.data.emergencyContactEmail)
                    this.commit("setEmergencyContactPhone", response.data.emergencyContactPhone)
                    this.commit("setEmergencyContactName", response.data.emergencyContactName)

                    // context.commit("setBookingList",response.data)

                    let cruiseId = response.data.sail.cruise.id;

                    return context.dispatch("loadCruiseRoomList", cruiseId);
                })
                .then(() => {
                    return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+id+"/payments",{headers});
                })
                .then((response) => {
                    context.commit("setPaymentList", response.data)
                    return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+id+"/payments/refund",{headers});
                })
                .then((response) => {
                    context.commit("setRefundList", response.data)
                    return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+id+"/history",{headers});
                })
                .then((response) => {
                    context.commit("setHistoryList", response.data)
                    return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+id+"/payments/check",{headers});
                })
                .then((response) => {
                    context.commit("setCheckBookingPayments", response.data)
                })
        },
        loadBookingArchived(context, id){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+id+"/archived",{headers})
                .then((response) => {
                    context.commit("setBooking",response.data)

                    let passengers = response.data.bookingPassengers;
                    for(let i=0;i<passengers.length;i++){
                        passengers[i].cruiseRoomId = passengers[i].bookingRoom.cruiseRoomId
                    }

                    this.commit("setPassengers", passengers)
                    this.commit("setSail", response.data.sail);
                    this.commit("setContactEmail", response.data.contactEmail)
                    this.commit("setContactPhone", response.data.contactPhone)
                    this.commit("setContactName", response.data.contactName)
                    this.commit("setEmergencyContactEmail", response.data.emergencyContactEmail)
                    this.commit("setEmergencyContactPhone", response.data.emergencyContactPhone)
                    this.commit("setEmergencyContactName", response.data.emergencyContactName)

                    // context.commit("setBookingList",response.data)

                    let cruiseId = response.data.sail.cruise.id;

                    return context.dispatch("loadCruiseRoomList", cruiseId);
                })
                .then(() => {
                    return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+id+"/payments",{headers});
                })
                .then((response) => {
                    context.commit("setPaymentList", response.data)
                    return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+id+"/payments/refund",{headers});
                })
                .then((response) => {
                    context.commit("setRefundList", response.data)
                    return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+id+"/history",{headers});
                })
                .then((response) => {
                    context.commit("setHistoryList", response.data)
                    return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+id+"/payments/check",{headers});
                })
                .then((response) => {
                    context.commit("setCheckBookingPayments", response.data)
                })
        },
        checkChange(context){
            let request = {
                bookingId: context.getters.getBooking.id,
                sailId: context.getters.getBooking.sail.id,
                contactName: context.getters.getContactName,
                contactEmail: context.getters.getContactEmail,
                contactPhone: context.getters.getContactPhone,
                passengerInfos: context.getters.getPassengers,
                reCalculatePrices : context.getters.getReCalculate,
                agentId : 1
            }

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/change/check",request,{headers})
                .then((response) => {
                    context.commit("setChangeResponse",response.data)
                    return response.data;
                })
        },
        change(context, agency){
            let request = {
                bookingId: context.getters.getBooking.id,
                sailId: context.getters.getBooking.sail.id,
                contactName: context.getters.getContactName,
                contactEmail: context.getters.getContactEmail,
                contactPhone: context.getters.getContactPhone,
                emergencyContactName: context.getters.getEmergencyContactName,
                emergencyContactEmail: context.getters.getEmergencyContactEmail,
                emergencyContactPhone: context.getters.getEmergencyContactPhone,
                passengerInfos: context.getters.getPassengers,
                agentId : context.getters.getBooking.agentId,
                bedOption: context.getters.getBooking.bedOption,
                accommodationType : context.getters.getBooking.accommodationType,
                reCalculatePrices : context.getters.getReCalculate,
                forcePartialPayment: true
            }

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/change",request,{headers})
                .then((response) => {
                    let historyList = context.getters.getHistoryList;
                    historyList.push(context.getters.getBooking)
                    context.commit("setHistoryList", historyList);
                    context.commit("setBooking", response.data.booking)
                    context.commit("setReservationEdit", false);
                    return response.data;
                })
        },
        remotePayment(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/remotePayment/send",request,{headers});
        },
        createRefund(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/payment/refund",request,{headers});
        },
        createBookingDiscount(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/discount",request,{headers})
                .then(response => {
                    context.commit("setBooking", response.data);

                    return response.data;
                })
        },
        createBookingPenalty(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/penalty",request,{headers})
                .then(response => {
                    context.commit("setBooking", response.data);

                    return response.data;
                })
        },
        postCancel(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/cancel",request,{headers})
                .then(response => {
                    return context.dispatch("loadBooking", response.data.booking.id);
                });
        },
        postNoShow(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/no-show",request,{headers})
                .then(response => {
                    return context.dispatch("loadBooking", response.data.booking.id);
                });
        },
        postComplimentary(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/complimentary",request,{headers})
                .then(response => {
                    return context.dispatch("loadBooking", response.data.id);
                });
        },
        useCoupon(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/useCoupon",request,{headers})
                .then(() => {
                    return context.dispatch("loadCouponList");
                });
        },
        loadBookingNotes : (context, {bookingId}) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+bookingId+"/notes",{headers})
                .then((response) => {
                    context.commit("setBookingNotes", response.data);
                    return response.data;
                })
        },
        createBookingNote(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/booking/note",request,{headers})
                .then(response => {
                    let bookingNotes = context.getters.getBookingNotes;

                    bookingNotes.push(response.data);
                    context.commit("setBookingNotes",bookingNotes);

                    return response.data;
                })
        },
        deleteBookingNote : (context, id) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.delete(context.getters.getServiceUrl + "/admin-api/booking/note/"+id,{headers});
        },
        loadBookingActionHistoryList : (context, historyReferenceId) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/booking/action-history/byReferenceId/"+historyReferenceId,{headers})
                .then((response) => {
                    context.commit("setBookingActionHistoryList", response.data);
                    return response.data;
                })
        },
        postConfirmBooking : (context, {bookingId}) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+bookingId+"/confirm",{headers})
                .then((response) => {
                    return response.data;
                })
        },
        generateAndDownloadVisaKit: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/visa-kit/generate?bookingId="+request.bookingId, {headers, responseType: 'arraybuffer'})
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'visa'+request.bookingId+'.xls'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    return response.data;
                })
        },
        toggleProformaLock: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/booking/"+request.id+"/update-proforma-lock/"+request.lock,{headers})
                .then((response) => {
                    return response.data;
                })
        }
    }
}

